<template>
  <div>
    <v-list>
      <!-- 일반 버튼 리스트 -->
      <v-list-tile
        class="add-btn-basic cursor"
        v-for="(item, index) in basicButtons()" :key="index">
        <v-list-tile-content @click="sendScenario(item)">
          <v-list-tile-title class="fs-14" v-html="item.text"></v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action style="min-width: 24px;" v-if="item.type === 'LINK_BUTTON'" @click="sendScenario(item)">
          <span class="grey--text fs-18 mr-1">
            <i class="material-icons move-btn">keyboard_arrow_right</i>
          </span>
        </v-list-tile-action>
        <v-list-tile-action style="min-width: 24px;" v-else-if="item.type === 'TEL_BUTTON'" @click="sendScenario(item)">
          <span class="fs-18 mr-1">
            <i class="fas fa-phone tel-btn"></i>
          </span>
        </v-list-tile-action>
        <v-list-tile-action style="min-width: 24px;" v-else-if="item.type === 'URL_BUTTON'" @click="sendScenario(item)">
          <span class="fs-18 mr-1">
            <i class="material-icons url-btn">link</i>
          </span>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider v-if="counselorButtons().length > 0" class="my-2 mx-2 border-dashed"></v-divider>
    <!-- 상담사 연결 버튼 리스트 -->
    <v-list>
      <v-list-tile
        class="add-btn-basic chat cursor" v-for="(item, index) in counselorButtons()" :key="index">
        <v-list-tile-content v-if="item.type === 'COUNSELOR_BUTTON'"  @click="sendScenario(item)">
          <v-list-tile-title class="ml-2 fs-14 black--text" v-html="item.text"></v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action @click="sendScenario(item)">
          <span class="grey--text fs-18 mr-2 mt-2">
            <img :src="getCounselorIcon(item.channelName)" alt="相談するアイコン" width="24"/>
          </span>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import Util from '@/util'
import Uuid from 'vue-uuid'
import eventBus from '@/event_bus'
import util from 'util/'

export default {
  name: 'scenario_item_buttons',
  props: [
    'buttons', 'brandKey', 'chatRoomId', 'preview'
  ],
  data () {
    return {
      uuid: Uuid.v1,
      loading: false
    }
  },
  methods: {
    sendScenario (item) {
      // 필수 값이 존재하지 않는 경우, 이벤트를 막도록 한다.
      if (this.brandKey === undefined || this.chatRoomId === undefined) return

      if (this.preview) {
        eventBus.$emit('send-preview', item)
      } else {
        // 전화버튼일 경우, 모바일에서만 작동하도록
        if (item.type === 'TEL_BUTTON') {
          if (!util.isMobile()) {
            this.$alertMsg('モバイルデバイスでサポートされています。')
            return
          }
        }
        eventBus.$emit('send-scenario', item)
      }
    },
    getSenderUid () {
      let sid = Util.getLoginIdParam() ? Util.getLoginIdParam() : Util.getSenderUid()
      if (!sid) {
        sid = this.$uuid.v1()
        Util.setSenderUid(sid)
      }
      return sid
    },
    getCounselorIcon (channelName) {
      return util.getCounselorIcon(channelName)
    },
    basicButtons () {
      // 타입 오름차순 - 버튼 순서 변경이 가능하도록 개선하여 기존 버튼 타입별로 정렬하는 부분 주석처리함
      // return this.buttons.filter(b => b.type !== 'COUNSELOR_BUTTON').sort(function (a, b) {
      //   return a.type < b.type ? -1 : a.type > b.type ? 1 : 0
      // })
      return this.buttons.filter(b => b.type !== 'COUNSELOR_BUTTON')
    },
    counselorButtons () {
      return this.buttons.filter(b => b.type === 'COUNSELOR_BUTTON')
    }
  }
}
</script>

<style scoped>
  @import url("../../../../../menus/chatbot/fragments/fragments/css/chatbot_editor.css");
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/scenario/item/scenario_item_buttons.vue